import { Form, Input } from "antd";

import ContentPadding from "../ContentConfig/ContentPadding";


export default () => {


  return (
    <>
      <Form.Item
          label="Template ID List"
          name="templateIdList"
          rules={[{ required: true }]}
        >
        <Input />
      </Form.Item>
      <ContentPadding />
    </>
  );
};
